import React from 'react';
import { SortableElement } from 'react-sortable-hoc';
import { ReactComponent as SortIcon } from './sort.svg'

const SortableItem = (props) => {
    return <li style={{ display: 'flex', alignItems: 'center' }}><SortIcon /><p style={{ marginLeft: 10 }}>{props.value}</p></li>
}

export default SortableElement(SortableItem);